/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffMemoryVoiceSignedurl200Response
 */
export interface PostLiffMemoryVoiceSignedurl200Response {
    /**
     * 
     * @type {string}
     * @memberof PostLiffMemoryVoiceSignedurl200Response
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffMemoryVoiceSignedurl200Response
     */
    filePath: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffMemoryVoiceSignedurl200Response
     */
    signedUrl: string;
    /**
     * 
     * @type {object}
     * @memberof PostLiffMemoryVoiceSignedurl200Response
     */
    fields: object;
}

/**
 * Check if a given object implements the PostLiffMemoryVoiceSignedurl200Response interface.
 */
export function instanceOfPostLiffMemoryVoiceSignedurl200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "filePath" in value;
    isInstance = isInstance && "signedUrl" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function PostLiffMemoryVoiceSignedurl200ResponseFromJSON(json: any): PostLiffMemoryVoiceSignedurl200Response {
    return PostLiffMemoryVoiceSignedurl200ResponseFromJSONTyped(json, false);
}

export function PostLiffMemoryVoiceSignedurl200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffMemoryVoiceSignedurl200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'filePath': json['filePath'],
        'signedUrl': json['signedUrl'],
        'fields': json['fields'],
    };
}

export function PostLiffMemoryVoiceSignedurl200ResponseToJSON(value?: PostLiffMemoryVoiceSignedurl200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'filePath': value.filePath,
        'signedUrl': value.signedUrl,
        'fields': value.fields,
    };
}

